import { PortalOrderPage } from '@/pages/portal/order/PortalOrderPage';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/customer/_customer-authenticated/orders/$orderId')({
	component: CustomerOrderDetailRoute,
});

function CustomerOrderDetailRoute() {
	return <PortalOrderPage />;
}
